

<div class="spacer">
    <p-panel>
        <div class="container-fluid">
        <div class="inner-container">
            <span>You are not authorized to access this page. Please submit a ticket to the IS Service Desk - Parts
                Logistics Input Output System for access. </span>
        </div>
    </div>
    </p-panel>
</div>